export const queryKeys = {
  userInfo: "user-info",
  userUploadedFiles: "user-uploaded-files",
  deleteUserUploadedFile: "delete-user-uploaded-file",

  userTranscriptionList: "user-transcription-list",
  userSpecificTranscription: "user-specific-transcription",
  userSpecificTranscriptionMutation: "user-specific-transcription-mutation",
  userSpecificTranscriptionDelete: "user-specific-transcription-delete",
  userSpecificTranscriptionSave: "user-specific-transcription-save",
  userExampleTranscription: "user-example-transcription",
  userSpecificTranscriptionShareable: "user-specific-transcription-shareable",

  userTranslationList: "user-translation-list",
  userSpecificTranslation: "user-specific-translation",
  userSpecificTranslationSave: "user-specific-translation-save",
  userSpecificTranslationMutation: "user-specific-translation-mutation",
  userSpecificTranslationDeleteMutation: "user-specific-translation-delete-mutation",

  userAllCaptions: "user-all-captions",
  userSpecificCaption: "user-specific-caption",
  publicCaption: "public-caption",
  postUserSpecificCaption: "post-user-specific-caption",
  putUserSpecificCaption: "put-user-specific-caption",
  getCaptionRenders: "get-caption-renders",
  deleteCaption: "delete-caption",
  renderCaption: "render-caption",
  renderProgress: "render-progress",
  translateCaption: "translate-caption",
  viralizeCaption: "viralize-caption",

  transcribe: "transcribe",
  transcriptionStatus: "transcription-status",
  translate: "translate",

  uploadFile: "upload-file",
  uploadYoutube: "upload-youtube",
  uploadFileV2: "upload-file-v2",
  uploadFileWithUrl: "upload-file-with-url",
  redeemTrialLinkClaim: "redeem-trial-link-claim",
  mediaDuration: "media-duration",
  getJobStatus: "get-job-status",
  processJob: "process-job",

  createYoutubeBlogPost: "create-youtube-blog-post",
  createYoutubeSummaryPost: "create-youtube-summary-post",
  chatWithTranscript: "chat-with-transcript",
  getFileMutation: "get-file-mutation",

  createCheckoutSession: "create-checkout-session",

  findReplaceTemplateList: "find-replace-template-list",
  findReplaceTemplatePost: "find-replace-template-post",
  findReplaceTemplate: "find-replace-template",
  findReplaceTemplateDelete: "find-replace-template-delete",
  findReplaceTemplatePut: "find-replace-template-put",

  generateUserApiKey: "generate-user-api-key",
  renameUserFile: "rename-user-file",
  updateUserLocale: "update-user-locale",
  updateUserFileSort: "update-user-file-sort",
  updateUserFilesPerPage: "update-user-files-per-page",
  onboardingStatus: "onboarding-status",
  onboardingQuestions: "onboarding-questions",
  saveOnboardingResponses: "save-onboarding-responses",
  instagramPreview: "instagram-preview",
  socialPreview: "social-preview",
  socialMetadata: "social-metadata",
  socialInsights: "social-insights",
  jobTranscription: "job-transcription",
  magicTools: "magic-tools",
  magicToolRun: "magic-tool-run",

  researchProjects: "research-projects",
  researchProject: "research-project",
  researchItems: "research-items",
  researchItem: "research-item",

  getDefaultTemplates: "get-default-templates",
  getUserTemplates: "get-user-templates",
  postUserTemplate: "post-user-template",
  putUserTemplate: "put-user-template",
};
